import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";

Vue.use(VueRouter);
const defaultPath = "/financial-tv";
const routes = [
  { path: "/plus", redirect: "/plus" + defaultPath },
  {
    path: "/",
    redirect: "/financial-tv",
  },
  {
    path: "/:lang?/plus/financial-tv", //todo: write /:lang?/plus in parent path
    component: () =>
        import(
            /* webpackChunkName: "financial-tv" */ "@/views/plus/itemList/WebTv.vue"
            ),
  },
  {
    path: "/:lang?/plus/financial-tv/:id",
    component: () =>
        import(
            /* webpackChunkName: "financial-tv-item" */ "@/views/plus/itemPages/WebtvItem.vue"
            ),
    name: "financial-tv-item"
  },
  {
    path: "/:lang?/plus/trading-signals",
    component: () =>
        import(
            /* webpackChunkName: "trading-signals" */ "@/views/plus/Signals.vue"
            ),
    name: "trading-signals"
  },
  {
    path: "/:lang?/plus/news",
    component: () =>
        import(
            /* webpackChunkName: "news" */ "@/views/plus/itemList/News.vue"
            ),
  },
  {
    path: "/:lang?/plus/news/:id",
    component: () =>
        import(
            /* webpackChunkName: "news-item" */ "@/views/plus/itemPages/NewsItem.vue"
            ),
    name: "news-item"
  },
  {
    path: "/:lang?/plus/webinars",
    component: () =>
        import(
            /* webpackChunkName: "webinars" */ "@/views/plus/itemList/Webinars.vue"
            ),
  },
  {
    path: "/:lang?/plus/webinars/:id",
    component: () =>
        import(
            /* webpackChunkName: "webinars-item" */ "@/views/plus/itemPages/WebinarsItem.vue"
            ),
    name: "webinars-item"
  },
  {
    path: "/:lang?/plus/webinars/:id/thank-you",
    component: () =>
        import(
            /* webpackChunkName: "webinars-thanks-you" */ "@/views/plus/thankYou/Webinars"
            ),
  },
  {
    path: "/:lang?/plus/ebooks",
    component: () =>
        import(
            /* webpackChunkName: "ebook" */ "@/views/plus/itemList/Ebooks.vue"
            ),
  },
  {
    path: "/:lang?/plus/ebooks/:id",
    component: () =>
        import(
            /* webpackChunkName: "ebook-item" */ "@/views/plus/itemPages/EbooksItem.vue"
            ),
    name: "ebooks-item"
  },
  {
    path: "/:lang?/plus/ebooks/:id/thank-you",
    component: () =>
        import(
            /* webpackChunkName: "ebook-thanks-you" */ "@/views/plus/thankYou/Ebooks"
            ),
  },
  {
    path: "/:lang?/instruments/:symbol",
    component: () =>
        import(
            /* webpackChunkName: "instruments" */ "@/views/plus/instruments/Instruments.vue"
            ),
  },
  {
    path: "/404",
    alias: "*",
    name: "NotFound",
    component: () =>
      import(/* webpackChunkName: "notfound" */ "@/views/NotFound.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  // base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  window.socket.removeAllListeners("tick"); //would have prefferably located at relevant component's "destroy" listener but for some reason "destroy" fires after the new component's "created" and therefore  canceling the new socket listener
  if (
    !store.state.showLoaderUntilUpdateUserStatusReturns &&
    store.state.pathswhichRequiresWaitingForUserStatus.includes(to.name)
  ) {
    //can't be located inside the relevant components, because sometimes they loads after the login status callback is being called
    store.dispatch("activateShowLoaderUntilUpdateUserStatusReturns");
  }

  const cond1 = ["fr", "es", "pt", "ar", "de", "it"].includes(store.state.lang);
  const cond2 = new RegExp("/(fr|es|pt|ar|de|it)/").test(to.fullPath);
  if (cond1 && !cond2) {
    const nextPath = "/" + store.state.lang + to.fullPath;
    next({ path: nextPath });
  } else {
    next();
  }
});

// router.beforeEach((to, from, next) => { //itay
//     if(to.fullPath.indexOf('plus') === -1){
//         console.log("to",to)
//         console.log("from", from)
//         const nextPath = "/fr/plus"+to.path;
//         next({ path: nextPath });
//     } else{
//         next();
//     }
//
// })

// router.beforeEach((to, from, next) => {
// let loggedIn = true;
// if(!loggedIn) {
//     store.commit('setShowLoginModal', true);
// } else {
//     next();
// }
// });

export default router;
